import { useAppActivity } from "@/contexts/AppActivityContext";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const HIDDEN_ROUTES = ["/mirror", "/check-in", "/onboarding", "/auth", "/welcome", "/splash", "/processing"];

const MediaBanner = () => {
  const { activeMedia, stopMedia, activeActivity } = useAppActivity();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (HIDDEN_ROUTES.some(r => pathname.startsWith(r))) return null;

  const topOffset = activeActivity ? 44 : 0;

  return (
    <AnimatePresence>
      {activeMedia && (
        <motion.div
          initial={{ y: -48, opacity: 0 }}
          animate={{ y: topOffset, opacity: 1 }}
          exit={{ y: -48, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="fixed top-0 left-0 right-0 z-[299]"
          style={{ maxWidth: "480px", margin: "0 auto", paddingTop: "env(safe-area-inset-top, 0px)" }}
        >
          <div
            className="flex items-center justify-between px-4 py-2"
            style={{
              background: "linear-gradient(90deg, hsl(265 40% 10%), hsl(265 60% 8%))",
              borderBottom: "1px solid hsl(265 60% 50% / 0.25)",
              backdropFilter: "blur(12px)",
            }}
          >
            <button onClick={() => navigate(activeMedia.route)} className="flex items-center gap-2.5 flex-1">
              <span className="text-[15px]">{activeMedia.emoji}</span>
              <div>
                <p className="text-[11px] font-display font-semibold text-white leading-none">{activeMedia.label}</p>
                <p className="text-[9px] font-display mt-0.5" style={{ color: "hsl(265 60% 60% / 0.70)" }}>A tocar</p>
              </div>
            </button>
            <div className="flex items-center gap-3">
              <motion.div className="flex gap-[2px] items-end h-[14px]">
                {[4, 8, 6, 10, 5].map((h, i) => (
                  <motion.div key={i} className="w-[2px] rounded-full" style={{ background: "hsl(265 60% 60%)" }}
                    animate={{ height: [h, h * 1.8, h] }} transition={{ duration: 0.6 + i * 0.1, repeat: Infinity, ease: "easeInOut" }} />
                ))}
              </motion.div>
              <button onClick={() => stopMedia()} className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: "hsl(0 70% 50% / 0.15)", border: "1px solid hsl(0 70% 50% / 0.30)" }}>
                <X size={10} style={{ color: "hsl(0 70% 65%)" }} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MediaBanner;
